import { render, staticRenderFns } from "./patientList.vue?vue&type=template&id=77b6840b&scoped=true"
import script from "./patientList.vue?vue&type=script&lang=js"
export * from "./patientList.vue?vue&type=script&lang=js"
import style0 from "./patientList.vue?vue&type=style&index=0&id=77b6840b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6840b",
  null
  
)

export default component.exports